/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Preview_Generate_HintInputs */



/**
* | output |
* | --- |
* | "Click Generate Preview to see subtitle" |
*
* @param {Image_Export_Preview_Generate_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_preview_generate_hint = /** @type {((inputs?: Image_Export_Preview_Generate_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Preview_Generate_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cliquez sur Generer la previsualisation pour voir le sous-titre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Klicken Sie auf „Vorschau generieren“, um die Untertitel anzuzeigen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fare clic su Genera anteprima per vedere i sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нажмите «Создать предварительный просмотр», чтобы увидеть субтитры.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Haga clic en Generar vista previa para ver los subtítulos.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("点击“生成预览”查看字幕")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プレビューを生成するをクリックすると字幕が表示されます")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपशीर्षक देखने के लिए पूर्वावलोकन उत्पन्न करें पर क्लिक करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Clique em Gerar Pré-visualização para ver a legenda.")
	return /** @type {LocalizedString} */ ("Click Generate Preview to see subtitle")
});